import React, {useEffect} from 'react';
import type {WithRouterProps} from 'react-router';
import {withRouter} from 'react-router';

import {TeacherDashboard} from './TeacherDashboard';

/** Renders the teacher dashboard at /home. */
const TeacherDashboardGate = withRouter(({location, router}: WithRouterProps<{}>) => {
  const pathname = location?.pathname ?? '/home';

  useEffect(() => {
    if (pathname !== '/home') {
      // Student child routes (/home/assignments etc.) have no teacher equivalent.
      router.replace('/home');
    }
  }, [pathname, router]);

  return <TeacherDashboard location={location} />;
});

export default TeacherDashboardGate;
